import { Checkbox } from "ui/forms/formik-elements";
import type { BooleanValue, SetupValueProps } from "../types";
import { FormField } from "../../types";

const Boolean = ({
    values,
    onChange,
    setFieldTouched,
    handleBlur
}: SetupValueProps<BooleanValue>) => (
    <Checkbox
        setFieldValue={(_, value) => (
            onChange!(value)
        )}
        setFieldTouched={setFieldTouched}
        label='Boolean (0/1) Setup Value'
        handleBlur={handleBlur}
        CheckboxProps={{
            inputProps: {
                'aria-label': 'Enabled'
            },
            name: FormField.SetupValue,
            checked: values[FormField.SetupValue].value
        }}
    />
);

export default Boolean;
